type ShouldIndexInput = {
  /** True when the storefront tenant is in preview mode (not a real customer-facing site). */
  preview: boolean;
  /** Storefront-level SEO toggle from `preferences.seo`. False ⇒ tenant has opted out of indexing. */
  seoEnabled: boolean;
};

/**
 * Whether search engines should be allowed to index a page on this storefront.
 *
 * Mirrors the legacy `shouldIndex` — preview tenants and tenants with SEO
 * turned off are denied. Per-page rules (e.g. unlisted experiences) are
 * handled outside this function; storefronts already 404 those upstream.
 */
export function shouldIndex({ preview, seoEnabled }: ShouldIndexInput): boolean {
  return !preview && seoEnabled;
}
